import { fromCallback, fromPromise } from 'xstate5';

import {
  addBroadcastEventsListener,
  broadcastLogInEvent,
  broadcastLogOutEvent,
  closeAuthBroadcastChannel,
  initAuthBroadcastChannel,
  removeBroadcastEventsListener,
} from '../utils';

import type { CurrentCustomerContextData, SessionData } from './types';

// ─────────────────────────────────────────────────────────────────────────────

const authBroadcast = fromCallback<AuthBroadcastEvent>(({ receive }) => {
  const authBroadcastChannel = initAuthBroadcastChannel();

  addBroadcastEventsListener(authBroadcastChannel);

  receive((event) => {
    postAuthBroadcastEvent(authBroadcastChannel, event);
  });

  return () => {
    removeBroadcastEventsListener(authBroadcastChannel);
    closeAuthBroadcastChannel(authBroadcastChannel);
  };
});

const fetchCustomer = fromPromise<CurrentCustomerContextData>(async () => {
  throw new Error('`fetchCustomer` actor is not provided.');
});

const fetchSession = fromPromise<SessionData>(async () => {
  throw new Error('`fetchSession` actor is not provided.');
});

export const AuthMachineActors = {
  authBroadcast,
  fetchCustomer,
  fetchSession,
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function postAuthBroadcastEvent(
  authBroadcastChannel: AuthBroadcastChannel,
  event: AuthBroadcastEvent,
) {
  if (event.type === 'BROADCAST_LOG_IN') {
    broadcastLogInEvent(authBroadcastChannel);

    return;
  }

  broadcastLogOutEvent(authBroadcastChannel);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type AuthBroadcastChannel = ReturnType<typeof initAuthBroadcastChannel>;

type AuthBroadcastEvent = { type: 'BROADCAST_LOG_IN' } | { type: 'BROADCAST_LOG_OUT' };
